import { computed } from "vue";
import { useWindowSize } from "@vueuse/core";
import { useUtils } from "@/composables/useUtils";

export const FRAME_WIDTH = 600;

export const useDesktopFrame = () => {
  const { isMobile, isDesktopJourneyEnabled } = useUtils();
  const { width } = useWindowSize();

  const showFrame = computed(
    () => isDesktopJourneyEnabled && !isMobile && width.value > FRAME_WIDTH,
  );

  return { showFrame, frameWidth: FRAME_WIDTH };
};
